// src/components/ToastNotification.jsx
import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

/**
 * Toast moderno estilo Apple
 * @param {Object} props
 * @param {boolean} props.show - Se o toast está visível
 * @param {function} props.onClose - Callback ao fechar
 * @param {string} props.title - Título do toast
 * @param {string} props.message - Mensagem do toast
 * @param {string} props.variant - Tipo: "success", "danger", "warning", "info"
 * @param {number} props.delay - Tempo em ms antes de auto-fechar (padrão: 4000)
 */
export default function ToastNotification({
  show = false,
  onClose = () => {},
  title = "",
  message = "",
  variant = "success",
  delay = 4000,
}) {
  const bgColor =
    {
      success: "dark",
      danger: "danger",
      warning: "warning",
      info: "info",
    }[variant] || "dark";

  return (
    <ToastContainer
      position="bottom-end"
      className="p-3"
      style={{ zIndex: 9999 }}
    >
      <Toast
        bg={bgColor}
        onClose={onClose}
        show={show}
        delay={delay}
        autohide
        style={{
          minWidth: 300,
          borderRadius: 16,
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        }}
      >
        <Toast.Header
          closeButton={true}
          closeVariant="white"
          style={{
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            background: "transparent",
          }}
        >
          <strong className="me-auto text-white">{title}</strong>
        </Toast.Header>
        {message && (
          <Toast.Body className="text-white" style={{ paddingTop: 0 }}>
            {message}
          </Toast.Body>
        )}
      </Toast>
    </ToastContainer>
  );
}
